const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP =
    "Uses record selected in the navigation's criteria to filter a given control's contents. E.g. Locations in an inventory. Requires to be on a Navigation Selected Context Page.";

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);
    line1OfInputs
        .appendField('   Navigation Selection Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');

    // line 2 of inputs
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Match Using Criteria For')
        .appendField('  Property Name:')
        .appendField(new Blockly.FieldTextInput(''), 'propertyName');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation', 'propertyName']);
    //we might never need/want the MDC user  to change this. But just in case put it on the code.
    code.criteriaProperty = 'criteria';
    return code;
}

/** Builds the filter metadata fragment for the ByNavigationSelectionCriteria block. */
function asDataDictionary(hNode, context) {
    const { namespace, relation, criteriaProperty, propertyName } = hNode;
    //we don't know much. Hopefully from elsewhere there is a more complete definition.
    //But register what we know regardless, as that helps with finding incorrect configurations

    //we DO know that the navigated relation has a criteria object
    //And in it, there is at least 1 criteria: `propertyName`
    //We do NOT know what criteria operations it can contain.
    // The criteria structure is documented but not enforced in the data dictionary at this level.
    const subDataDictionary = {};

    //we also know that whatever relation context we are in, is expected to have `propertyName` as property
    //but we don't know the type from here, so just mark with propertyName
    const partialTypeDefinition = {
        [propertyName]: {
            'x-propertyName': propertyName
        }
    };
    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
